module.exports = __webpack_public_path__ + "static/img/06.b2a7ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/06.jpg
// module id = /ew0
// module chunks = 0